import { Alert, AlertDescription, AlertIcon, AlertTitle, Stack, useToast } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import Routes from "./routes";
import "./assets/css/app.css";
import ClientSidebar from "./components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import PracticeSidebar from "./components/PracticeSidebar";
import Cookies from "js-cookie";
import InternalSidebar from "./components/InternalSidebar";
import BusinessModal from "./components/Modals/BusinessModal";
import LoadUser from "./utils/LoadUser";

function SubscriptionBanner() {
  const business = useSelector((state: any) => state.selections.value?.business);
  const sub = business?.subscription;
  if (!sub) return null;
  const isExpired = sub.status === 'expired'
    || (sub.end_date && new Date(sub.end_date) < new Date());
  if (!isExpired) return null;
  return (
    <Alert status='warning' w={'98%'} mt={-6}>
      <AlertIcon />
      <AlertTitle>Subscription Expired!</AlertTitle>
      <AlertDescription>New document upload has been disabled as your subscription has been expired.</AlertDescription>
    </Alert>
  );
}

export const App = () => {
  const user = useSelector((state: any) => state.user.value);
  const location = useLocation();

  const toast = useToast();
  const dispatch = useDispatch();
  
  useEffect(() => {
    let raw: string | null | undefined = null;
    if (localStorage.getItem("user") !== null) {
      raw = localStorage.getItem("user");
    } else if (Cookies.get("user") !== undefined) {
      raw = Cookies.get("user");
    }
    if (!raw) return;
    try {
      const parsed = JSON.parse(raw);
      if (parsed && parsed.role) {
        LoadUser(parsed, dispatch, toast);
      }
    } catch {
      // corrupted session payload — ignore and require fresh login
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function Sidebar() {
    return (
      user?.role === 'dataentry' || user?.role === 'supervisor' ?
        (
          <InternalSidebar />
        )
        :
        (
          <ClientSidebar />
        )
    )
  }

  return (
    !user?.role
      ?
      (
        <Routes />
      )
      :
      (
        <Stack
          direction={'row'}
          overflowY={'hidden'}
          h={'100vh'}
        >
          {
            location.pathname.split("/")[1].toLowerCase() === "practice" ?
              (
                <PracticeSidebar />
              )
              :
              (
                <Sidebar />
              )
          }
          <Stack
            w={'full'}
            overflowY={'scroll'}
            align={'center'}
            overflowX={'hidden'}
          >
            {
              user?.role === 'client' &&
              (
                <Navbar />
              )
            }
            {
              !user?.business && (
                <BusinessModal />
              )
            }
            <Stack py={8} w={'full'} justify={"center"} align={'center'} spacing={4}>
              {
                user?.role === 'client' && <SubscriptionBanner />
              }
              <Routes />
            </Stack>
          </Stack>
        </Stack>
      )
  );
};